import {
  Dialog,
  DialogContent,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { IconBrandApple, IconBrandGooglePlay, IconDeviceMobile } from '@tabler/icons-react';

type StoreType = 'appstore' | 'googleplay';

interface AppDownloadModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  storeUrl?: string;
  storeType: StoreType;
  siteName?: string;
}

const storeConfig = {
  appstore: {
    name: 'App Store',
    icon: IconBrandApple,
    description: 'Scan the QR code with your phone to download from the App Store.',
    deviceText: 'Or visit the App Store directly on your iOS device.',
  },
  googleplay: {
    name: 'Google Play',
    icon: IconBrandGooglePlay,
    description: 'Scan the QR code with your phone to download from Google Play.',
    deviceText: 'Or visit Google Play directly on your Android device.',
  },
};

export function AppDownloadModal({
  open,
  onOpenChange,
  storeUrl,
  storeType,
  siteName = 'our app',
}: AppDownloadModalProps) {
  if (!storeUrl) return null;

  const config = storeConfig[storeType];
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(storeUrl)}&bgcolor=FFFFFF&color=000000&margin=0`;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <div className="flex flex-col items-center pt-6 pb-2">
          {/* Phone icon in circular background */}
          <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mb-6">
            <IconDeviceMobile className="h-10 w-10 text-primary" />
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold mb-3">Get {siteName}</h2>

          {/* Description */}
          <p className="text-muted-foreground text-center mb-8">
            {config.description}
          </p>

          {/* QR Code */}
          <div className="bg-white rounded-2xl p-4 shadow-sm border mb-8">
            <img
              src={qrCodeUrl}
              alt={`QR Code to download ${siteName}`}
              className="w-52 h-52"
            />
          </div>

          <p className="text-muted-foreground text-sm mb-6 text-center">
            {config.deviceText}
          </p>

          {/* Store button */}
          <Button asChild variant="secondary" size="lg" className="px-8">
            <a
              href={storeUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <config.icon className="h-5 w-5 mr-2" />
              View on {config.name}
            </a>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
